{
  "description": [
    "This is the list of IANA time zone names that we present in the UI. Since the frontend and backend use different time",
    "zone modules, an automated system test will verify that each time zone name in this list is successfully compiled",
    "by the backend in a formula."
  ],
  "zones": [
    "Africa/Abidjan",
    "Africa/Accra",
    "Africa/Nairobi",
    "Africa/Algiers",
    "Africa/Lagos",
    "Africa/Bissau",
    "Africa/Maputo",
    "Africa/Cairo",
    "Africa/Casablanca",
    "Africa/Ceuta",
    "Africa/El_Aaiun",
    "Africa/Johannesburg",
    "Africa/Juba",
    "Africa/Khartoum",
    "Africa/Monrovia",
    "Africa/Ndjamena",
    "Africa/Sao_Tome",
    "Africa/Tripoli",
    "Africa/Tunis",
    "Africa/Windhoek",
    "America/Adak",
    "America/Anchorage",
    "America/Port_of_Spain",
    "America/Araguaina",
    "America/Argentina/Buenos_Aires",
    "America/Argentina/Catamarca",
    "America/Argentina/Cordoba",
    "America/Argentina/Jujuy",
    "America/Argentina/La_Rioja",
    "America/Argentina/Mendoza",
    "America/Argentina/Rio_Gallegos",
    "America/Argentina/Salta",
    "America/Argentina/San_Juan",
    "America/Argentina/San_Luis",
    "America/Argentina/Tucuman",
    "America/Argentina/Ushuaia",
    "America/Curacao",
    "America/Asuncion",
    "America/Atikokan",
    "America/Bahia_Banderas",
    "America/Bahia",
    "America/Barbados",
    "America/Belem",
    "America/Belize",
    "America/Blanc-Sablon",
    "America/Boa_Vista",
    "America/Bogota",
    "America/Boise",
    "America/Cambridge_Bay",
    "America/Campo_Grande",
    "America/Cancun",
    "America/Caracas",
    "America/Cayenne",
    "America/Panama",
    "America/Chicago",
    "America/Chihuahua",
    "America/Costa_Rica",
    "America/Creston",
    "America/Cuiaba",
    "America/Danmarkshavn",
    "America/Dawson_Creek",
    "America/Dawson",
    "America/Denver",
    "America/Detroit",
    "America/Edmonton",
    "America/Eirunepe",
    "America/El_Salvador",
    "America/Tijuana",
    "America/Fort_Nelson",
    "America/Fort_Wayne",
    "America/Fortaleza",
    "America/Glace_Bay",
    "America/Godthab",
    "America/Goose_Bay",
    "America/Grand_Turk",
    "America/Guatemala",
    "America/Guayaquil",
    "America/Guyana",
    "America/Halifax",
    "America/Havana",
    "America/Hermosillo",
    "America/Indiana/Knox",
    "America/Indiana/Marengo",
    "America/Indiana/Petersburg",
    "America/Indiana/Tell_City",
    "America/Indiana/Vevay",
    "America/Indiana/Vincennes",
    "America/Indiana/Winamac",
    "America/Inuvik",
    "America/Iqaluit",
    "America/Jamaica",
    "America/Juneau",
    "America/Kentucky/Louisville",
    "America/Kentucky/Monticello",
    "America/La_Paz",
    "America/Lima",
    "America/Los_Angeles",
    "America/Maceio",
    "America/Managua",
    "America/Manaus",
    "America/Martinique",
    "America/Matamoros",
    "America/Mazatlan",
    "America/Menominee",
    "America/Merida",
    "America/Metlakatla",
    "America/Mexico_City",
    "America/Miquelon",
    "America/Moncton",
    "America/Monterrey",
    "America/Montevideo",
    "America/Toronto",
    "America/Nassau",
    "America/New_York",
    "America/Nipigon",
    "America/Nome",
    "America/Noronha",
    "America/North_Dakota/Beulah",
    "America/North_Dakota/Center",
    "America/North_Dakota/New_Salem",
    "America/Ojinaga",
    "America/Pangnirtung",
    "America/Paramaribo",
    "America/Phoenix",
    "America/Port-au-Prince",
    "America/Rio_Branco",
    "America/Porto_Velho",
    "America/Puerto_Rico",
    "America/Punta_Arenas",
    "America/Rainy_River",
    "America/Rankin_Inlet",
    "America/Recife",
    "America/Regina",
    "America/Resolute",
    "America/Santarem",
    "America/Santiago",
    "America/Santo_Domingo",
    "America/Sao_Paulo",
    "America/Scoresbysund",
    "America/Sitka",
    "America/St_Johns",
    "America/Swift_Current",
    "America/Tegucigalpa",
    "America/Thule",
    "America/Thunder_Bay",
    "America/Vancouver",
    "America/Whitehorse",
    "America/Winnipeg",
    "America/Yakutat",
    "America/Yellowknife",
    "Antarctica/Casey",
    "Antarctica/Davis",
    "Antarctica/DumontDUrville",
    "Antarctica/Macquarie",
    "Antarctica/Mawson",
    "Pacific/Auckland",
    "Antarctica/Palmer",
    "Antarctica/Rothera",
    "Antarctica/Syowa",
    "Antarctica/Troll",
    "Antarctica/Vostok",
    "Europe/Oslo",
    "Asia/Riyadh",
    "Asia/Almaty",
    "Asia/Amman",
    "Asia/Anadyr",
    "Asia/Aqtau",
    "Asia/Aqtobe",
    "Asia/Ashgabat",
    "Asia/Atyrau",
    "Asia/Baghdad",
    "Asia/Qatar",
    "Asia/Baku",
    "Asia/Bangkok",
    "Asia/Barnaul",
    "Asia/Beirut",
    "Asia/Bishkek",
    "Asia/Brunei",
    "Asia/Kolkata",
    "Asia/Chita",
    "Asia/Choibalsan",
    "Asia/Shanghai",
    "Asia/Colombo",
    "Asia/Dhaka",
    "Asia/Damascus",
    "Asia/Dili",
    "Asia/Dubai",
    "Asia/Dushanbe",
    "Asia/Famagusta",
    "Asia/Gaza",
    "Asia/Hebron",
    "Asia/Ho_Chi_Minh",
    "Asia/Hong_Kong",
    "Asia/Hovd",
    "Asia/Irkutsk",
    "Europe/Istanbul",
    "Asia/Jakarta",
    "Asia/Jayapura",
    "Asia/Jerusalem",
    "Asia/Kabul",
    "Asia/Kamchatka",
    "Asia/Karachi",
    "Asia/Urumqi",
    "Asia/Kathmandu",
    "Asia/Khandyga",
    "Asia/Krasnoyarsk",
    "Asia/Kuala_Lumpur",
    "Asia/Kuching",
    "Asia/Macau",
    "Asia/Magadan",
    "Asia/Makassar",
    "Asia/Manila",
    "Asia/Nicosia",
    "Asia/Novokuznetsk",
    "Asia/Novosibirsk",
    "Asia/Omsk",
    "Asia/Oral",
    "Asia/Pontianak",
    "Asia/Pyongyang",
    "Asia/Qostanay",
    "Asia/Qyzylorda",
    "Asia/Rangoon",
    "Asia/Sakhalin",
    "Asia/Samarkand",
    "Asia/Seoul",
    "Asia/Srednekolymsk",
    "Asia/Taipei",
    "Asia/Tashkent",
    "Asia/Tbilisi",
    "Asia/Tehran",
    "Asia/Thimphu",
    "Asia/Tokyo",
    "Asia/Tomsk",
    "Asia/Ulaanbaatar",
    "Asia/Ust-Nera",
    "Asia/Vladivostok",
    "Asia/Yakutsk",
    "Asia/Yekaterinburg",
    "Asia/Yerevan",
    "Atlantic/Azores",
    "Atlantic/Bermuda",
    "Atlantic/Canary",
    "Atlantic/Cape_Verde",
    "Atlantic/Faroe",
    "Atlantic/Madeira",
    "Atlantic/Reykjavik",
    "Atlantic/South_Georgia",
    "Atlantic/Stanley",
    "Australia/Sydney",
    "Australia/Adelaide",
    "Australia/Brisbane",
    "Australia/Broken_Hill",
    "Australia/Currie",
    "Australia/Darwin",
    "Australia/Eucla",
    "Australia/Hobart",
    "Australia/Lord_Howe",
    "Australia/Lindeman",
    "Australia/Melbourne",
    "Australia/Perth",
    "CET",
    "Pacific/Easter",
    "CST6CDT",
    "EET",
    "Europe/Dublin",
    "Pacific/Port_Moresby",
    "Pacific/Tarawa",
    "Indian/Christmas",
    "Pacific/Palau",
    "Etc/UTC",
    "Europe/Amsterdam",
    "Europe/Andorra",
    "Europe/Astrakhan",
    "Europe/Athens",
    "Europe/London",
    "Europe/Belgrade",
    "Europe/Berlin",
    "Europe/Prague",
    "Europe/Brussels",
    "Europe/Bucharest",
    "Europe/Budapest",
    "Europe/Zurich",
    "Europe/Chisinau",
    "Europe/Copenhagen",
    "Europe/Gibraltar",
    "Europe/Helsinki",
    "Europe/Kaliningrad",
    "Europe/Kiev",
    "Europe/Kirov",
    "Europe/Lisbon",
    "Europe/Luxembourg",
    "Europe/Madrid",
    "Europe/Malta",
    "Europe/Minsk",
    "Europe/Monaco",
    "Europe/Moscow",
    "Europe/Paris",
    "Europe/Riga",
    "Europe/Rome",
    "Europe/Samara",
    "Europe/Saratov",
    "Europe/Simferopol",
    "Europe/Sofia",
    "Europe/Stockholm",
    "Europe/Tallinn",
    "Europe/Tirane",
    "Europe/Ulyanovsk",
    "Europe/Uzhgorod",
    "Europe/Vienna",
    "Europe/Vilnius",
    "Europe/Volgograd",
    "Europe/Warsaw",
    "Europe/Zaporozhye",
    "Indian/Chagos",
    "Indian/Cocos",
    "Indian/Kerguelen",
    "Indian/Mahe",
    "Indian/Maldives",
    "Indian/Mauritius",
    "Indian/Reunion",
    "Pacific/Kwajalein",
    "MET",
    "Pacific/Chatham",
    "Pacific/Apia",
    "Pacific/Bougainville",
    "Pacific/Chuuk",
    "Pacific/Efate",
    "Pacific/Enderbury",
    "Pacific/Fakaofo",
    "Pacific/Fiji",
    "Pacific/Galapagos",
    "Pacific/Gambier",
    "Pacific/Guadalcanal",
    "Pacific/Guam",
    "Pacific/Honolulu",
    "Pacific/Kiritimati",
    "Pacific/Kosrae",
    "Pacific/Majuro",
    "Pacific/Marquesas",
    "Pacific/Pago_Pago",
    "Pacific/Nauru",
    "Pacific/Niue",
    "Pacific/Norfolk",
    "Pacific/Noumea",
    "Pacific/Pitcairn",
    "Pacific/Pohnpei",
    "Pacific/Rarotonga",
    "Pacific/Tahiti",
    "Pacific/Tongatapu",
    "PST8PDT",
    "WET",
    {
      "name": "Etc/GMT+1",
      "displayName": "UTC-1"
    },
    {
      "name": "Etc/GMT+2",
      "displayName": "UTC-2"
    },
    {
      "name": "Etc/GMT+3",
      "displayName": "UTC-3"
    },
    {
      "name": "Etc/GMT+4",
      "displayName": "UTC-4"
    },
    {
      "name": "Etc/GMT+5",
      "displayName": "UTC-5"
    },
    {
      "name": "Etc/GMT+6",
      "displayName": "UTC-6"
    },
    {
      "name": "Etc/GMT+7",
      "displayName": "UTC-7"
    },
    {
      "name": "Etc/GMT+8",
      "displayName": "UTC-8"
    },
    {
      "name": "Etc/GMT+9",
      "displayName": "UTC-9"
    },
    {
      "name": "Etc/GMT+10",
      "displayName": "UTC-10"
    },
    {
      "name": "Etc/GMT+11",
      "displayName": "UTC-11"
    },
    {
      "name": "Etc/GMT+12",
      "displayName": "UTC-12"
    },
    {
      "name": "Etc/GMT-1",
      "displayName": "UTC+1"
    },
    {
      "name": "Etc/GMT-2",
      "displayName": "UTC+2"
    },
    {
      "name": "Etc/GMT-3",
      "displayName": "UTC+3"
    },
    {
      "name": "Etc/GMT-4",
      "displayName": "UTC+4"
    },
    {
      "name": "Etc/GMT-5",
      "displayName": "UTC+5"
    },
    {
      "name": "Etc/GMT-6",
      "displayName": "UTC+6"
    },
    {
      "name": "Etc/GMT-7",
      "displayName": "UTC+7"
    },
    {
      "name": "Etc/GMT-8",
      "displayName": "UTC+8"
    },
    {
      "name": "Etc/GMT-9",
      "displayName": "UTC+9"
    },
    {
      "name": "Etc/GMT-10",
      "displayName": "UTC+10"
    },
    {
      "name": "Etc/GMT-11",
      "displayName": "UTC+11"
    },
    {
      "name": "Etc/GMT-12",
      "displayName": "UTC+12"
    },
    {
      "name": "Etc/GMT-13",
      "displayName": "UTC+13"
    },
    {
      "name": "Etc/GMT-14",
      "displayName": "UTC+14"
    },
    "Africa/Addis_Ababa",
    "Africa/Asmara",
    "Africa/Asmera",
    "Africa/Bamako",
    "Africa/Bangui",
    "Africa/Banjul",
    "Africa/Blantyre",
    "Africa/Brazzaville",
    "Africa/Bujumbura",
    "Africa/Conakry",
    "Africa/Dakar",
    "Africa/Dar_es_Salaam",
    "Africa/Djibouti",
    "Africa/Douala",
    "Africa/Freetown",
    "Africa/Gaborone",
    "Africa/Harare",
    "Africa/Kampala",
    "Africa/Kigali",
    "Africa/Kinshasa",
    "Africa/Libreville",
    "Africa/Lome",
    "Africa/Luanda",
    "Africa/Lubumbashi",
    "Africa/Lusaka",
    "Africa/Malabo",
    "Africa/Maseru",
    "Africa/Mbabane",
    "Africa/Mogadishu",
    "Africa/Niamey",
    "Africa/Nouakchott",
    "Africa/Ouagadougou",
    "Africa/Porto-Novo",
    "Africa/Timbuktu",
    "America/Anguilla",
    "America/Antigua",
    "America/Argentina/ComodRivadavia",
    "America/Aruba",
    "America/Atka",
    "America/Buenos_Aires",
    "America/Catamarca",
    "America/Cayman",
    "America/Coral_Harbour",
    "America/Cordoba",
    "America/Dominica",
    "America/Ensenada",
    "America/Grenada",
    "America/Guadeloupe",
    "America/Indiana/Indianapolis",
    "America/Indianapolis",
    "America/Jujuy",
    "America/Knox_IN",
    "America/Kralendijk",
    "America/Louisville",
    "America/Lower_Princes",
    "America/Marigot",
    "America/Mendoza",
    "America/Montreal",
    "America/Montserrat",
    "America/Porto_Acre",
    "America/Rosario",
    "America/Santa_Isabel",
    "America/Shiprock",
    "America/St_Barthelemy",
    "America/St_Kitts",
    "America/St_Lucia",
    "America/St_Thomas",
    "America/St_Vincent",
    "America/Tortola",
    "America/Virgin",
    "Antarctica/McMurdo",
    "Antarctica/South_Pole",
    "Arctic/Longyearbyen",
    "Asia/Aden",
    "Asia/Ashkhabad",
    "Asia/Bahrain",
    "Asia/Calcutta",
    "Asia/Chongqing",
    "Asia/Chungking",
    "Asia/Dacca",
    "Asia/Harbin",
    "Asia/Istanbul",
    "Asia/Kashgar",
    "Asia/Katmandu",
    "Asia/Kuwait",
    "Asia/Macao",
    "Asia/Muscat",
    "Asia/Phnom_Penh",
    "Asia/Saigon",
    "Asia/Singapore",
    "Asia/Tel_Aviv",
    "Asia/Thimbu",
    "Asia/Ujung_Pandang",
    "Asia/Ulan_Bator",
    "Asia/Vientiane",
    "Asia/Yangon",
    "Atlantic/Faeroe",
    "Atlantic/Jan_Mayen",
    "Atlantic/St_Helena",
    "Australia/ACT",
    "Australia/Canberra",
    "Australia/LHI",
    "Australia/North",
    "Australia/NSW",
    "Australia/Queensland",
    "Australia/South",
    "Australia/Tasmania",
    "Australia/Victoria",
    "Australia/West",
    "Australia/Yancowinna",
    "Brazil/Acre",
    "Brazil/DeNoronha",
    "Brazil/East",
    "Brazil/West",
    "Canada/Atlantic",
    "Canada/Central",
    "Canada/Eastern",
    "Canada/Mountain",
    "Canada/Newfoundland",
    "Canada/Pacific",
    "Canada/Saskatchewan",
    "Canada/Yukon",
    "Chile/Continental",
    "Chile/EasterIsland",
    "Cuba",
    "Egypt",
    "Eire",
    "Etc/GMT",
    "Etc/Greenwich",
    "Etc/UCT",
    "Etc/Universal",
    "Etc/Zulu",
    "Europe/Belfast",
    "Europe/Bratislava",
    "Europe/Busingen",
    "Europe/Guernsey",
    "Europe/Isle_of_Man",
    "Europe/Jersey",
    "Europe/Ljubljana",
    "Europe/Mariehamn",
    "Europe/Nicosia",
    "Europe/Podgorica",
    "Europe/San_Marino",
    "Europe/Sarajevo",
    "Europe/Skopje",
    "Europe/Tiraspol",
    "Europe/Vaduz",
    "Europe/Vatican",
    "Europe/Zagreb",
    "GB",
    "GB-Eire",
    "GMT",
    "Greenwich",
    "Hongkong",
    "Iceland",
    "Indian/Antananarivo",
    "Indian/Comoro",
    "Indian/Mayotte",
    "Iran",
    "Israel",
    "Jamaica",
    "Japan",
    "Kwajalein",
    "Libya",
    "Mexico/BajaNorte",
    "Mexico/BajaSur",
    "Mexico/General",
    "Navajo",
    "NZ",
    "NZ-CHAT",
    "Pacific/Funafuti",
    "Pacific/Johnston",
    "Pacific/Midway",
    "Pacific/Ponape",
    "Pacific/Saipan",
    "Pacific/Samoa",
    "Pacific/Tarawa",
    "Pacific/Truk",
    "Pacific/Wake",
    "Pacific/Wallis",
    "Pacific/Yap",
    "Poland",
    "Portugal",
    "PRC",
    "ROK",
    "Singapore",
    "Turkey",
    "UCT",
    "Universal",
    "US/Alaska",
    "US/Aleutian",
    "US/Arizona",
    "US/Central",
    "US/East-Indiana",
    "US/Eastern",
    "US/Hawaii",
    "US/Indiana-Starke",
    "US/Michigan",
    "US/Mountain",
    "US/Pacific",
    "US/Samoa",
    "UTC",
    "W-SU",
    "Zulu"
  ]
}
